import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import api, { HomeFeedResolvedSection } from '@/services/api'

export const setHomeFeedSections = createAction<HomeFeedResolvedSection[]>('homeFeed/setSections')
export const setHomeFeedStatus = createAction<'idle' | 'loading' | 'loaded' | 'error'>(
  'homeFeed/setStatus',
)

/**
 * Cache-first load of the ordered home feed: keeps any already-cached sections
 * visible while refreshing from the network, mirroring iOS
 * `loadCachedResolvedSections` / `refreshResolvedSections`.
 */
export const loadHomeFeed = createAsyncThunk<void, void>(
  'homeFeed/load',
  async (_, { dispatch }) => {
    dispatch(setHomeFeedStatus('loading'))
    try {
      const sections = await api.resolveHomeFeedSections()
      dispatch(setHomeFeedSections(sections))
      dispatch(setHomeFeedStatus('loaded'))
    } catch (err) {
      console.error('Failed to load home feed:', err)
      dispatch(setHomeFeedStatus('error'))
    }
  },
)
